export default __webpack_public_path__ + "static/media/right-arrow.aa3d316c.svg";